/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';

import { Typography, AspectRatioBox } from '@atoms';
import { ReactComponent as ErrorIcon } from '@assets/icons/error.svg';

import s from './styles.module.less';

const Base = ({
  as: Component = 'div',
  children,
  onClick,
  description,
  image,
  alt,
  size,
  icon,
  extra,
  className,
  style,
  countryCode,
  day,
}) => {
  const isLarge = size === 'large';

  const aspect = isLarge ? 1 / 2 : 3 / 5;

  return (
    <Component className={clsx(s.root, s[size], onClick && s.clickable, className)} style={style} onClick={onClick}>
      {(image || countryCode) && !countryCode && (
        <div className={s.image}>
          <AspectRatioBox aspect={aspect}>
            {!countryCode && <img src={image} alt={alt} />}
            {/* {countryCode && (
              <ReactCountryFlag
                countryCode={countryCode}
                svg
                style={{
                  width: '50px',
                  height: '30px',
                }}
              />
            )} */}
          </AspectRatioBox>
        </div>
      )}
      {icon && (
        <div className={s.icon}>
          <img src={icon} alt={alt} />
        </div>
      )}
      {(children || description) && (
        <>
          <div className={clsx(s.content, children && description && s.spaceBetween)}>
            {children && <div className={s.label}>{children}</div>}
            {description && <div className={s.description}>{description}</div>}
            {day && <div className={s.day}>Day {day}</div>}
          </div>
          {extra && <div className={s.extra}>{extra}</div>}
        </>
      )}
    </Component>
  );
};

const InfoItem = ({ description, children, day, ...props }) => {
  const isLarge = props.size === 'large';

  const Label = isLarge ? Typography.Title : Typography.Text;
  const Description = isLarge ? Typography.Text : Typography.Note;

  return (
    <>
      <Base
        description={description && <Description>{description}</Description>}
        day={day && <Description>{day}</Description>}
        {...props}
      >
        <Label level={3}>{children}</Label>
      </Base>
    </>
  );
};

const WithError = ({ error, ...props }) => <InfoItem {...props} extra={error && <ErrorIcon />} />;

InfoItem.Base = Base;
InfoItem.WithError = WithError;

export default InfoItem;
